module.exports = __webpack_public_path__ + "img/04-B08.8464d51b.png";